import React from 'react'
import './skills.css'

const Skillscard = (props) => {
  return (
    <div className="skillsCards">
      <img src={props.img} alt={props.alt} className="skillsCardsImgs" />
      <h1 className="skillsCardsNames">{props.name}</h1>
    </div>
  //   <div className="skillCard">
  //       <img src={props.img} alt={props.alt} className="skillCardImg" />
  //       <h1 className="skillCardName">{props.name}</h1>
  //       <p className="skillCardPara">{props.content}</p>
  //   </div>
  )
}

export default Skillscard